exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tree-select .el-select__tags .el-tag .el-tag__close[data-v-ffeab266] {\n  display: none;\n}\n.tree-select .el-select__tags .el-tag .el-icon-close[data-v-ffeab266] {\n  display: none;\n}", ""]);

// exports
